//MARK: Done
export const ACCOUNT = {
  ACCOUNT: {
    ADD: "account/add",
  },
};
